<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { StatisticsItem } from '../models';
import { StatisticsStatus } from '../enums';

const props = defineProps<DataTableCellProps<any, StatisticsItem>>();
const { item } = toRefs(props);

const statusColorMap: Record<StatisticsStatus, string> = {
  [StatisticsStatus.ERROR]: 'red',
  [StatisticsStatus.GENERATING]: 'blue',
  [StatisticsStatus.GENERATED]: 'green'
};

const chipColor = computed(() => statusColorMap[item.value.data.status]);
</script>

<template>
  <div>
    <v-chip :color="chipColor">{{ $t(`statistics.status.${item.data.status}`) }}</v-chip>
  </div>
</template>
